import React from "react";
import { Landmark, Compass, Target } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pressureCards = [{
  title: "Affordability",
  description: "Tuition and total cost of attendance face mounting scrutiny from families, legislators, and accreditors.",
  icon: Landmark
}, {
  title: "Access",
  description: "Equitable pathways must reach learners who are working, place-bound, or first-generation.",
  icon: Compass
}, {
  title: "Relevance",
  description: "Programs and credentials must keep pace with what employers and the economy actually demand.",
  icon: Target
}];
export default function ExternalPressures() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="external-pressures" className="bg-primary text-primary-foreground py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {/* Section Eyebrow & Title */}
          <div className="max-w-3xl mb-14">
            <span className="block text-xs md:text-sm font-semibold uppercase tracking-widest text-ring mb-3">
              EXTERNAL PRESSURES
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-tight">
              Higher education is under pressure from every direction
            </h2>
          </div>

          {/* 3 Dark Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {pressureCards.map((card, index) => {
            const Icon = card.icon;
            return <div key={index} className="rounded-2xl border border-white/10 bg-white/5 p-8 lg:p-10 flex flex-col justify-start transition-transform duration-300 hover:border-white/20">
                  <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center text-ring mb-6">
                    <Icon className="w-6 h-6 stroke-[1.5]" />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-4">
                    {card.title}
                  </h3>
                  <p className="text-primary-foreground/80 leading-relaxed text-base">
                    {card.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}